// In framework/client/widgets/AIUsageSummaryWidget.widget.js

export default {
    name: "AIUsageSummaryWidget",
    type: "MultiDisplayWidget",
    description: "Summary of AI model usage tokens and costs.",
    roles: ["admin"],
    widget: {
        title: "AI Usage Summary",
        size: "medium",

        // --- FIX: Use the new dataProvider format ---
        dataProvider: {
            main: {
                rpc: "AdminAnalyticsRpc.getOverallUsageSummary"
                // RPC returns a single object, which is what MultiDisplayWidget expects for its 'main' data. No transform needed.
            }
        },

        items: [
            { label: "Total Requests", valueField: "totalRequests", format: "number", icon: "bi bi-arrow-repeat" },
            { label: "Prompt Tokens", valueField: "totalPromptTokens", format: "number", icon: "bi bi-input-cursor-text" },
            { label: "Completion Tokens", valueField: "totalCompletionTokens", format: "number", icon: "bi bi-chat-left-text-fill" },
            { label: "Total Tokens", valueField: "totalTokens", format: "number", icon: "bi bi-cpu-fill" },
            { label: "Estimated Cost", valueField: "totalCost", format: "currency", icon: "bi bi-currency-dollar" },
            { label: "Errors", valueField: "totalErrors", format: "number", icon: "bi bi-exclamation-triangle-fill" }
        ]
    }
};